import { useEffect } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const HEARTBEAT_INTERVAL_MS = 30 * 1000;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Fires a heartbeat to /api/admin/orestore/availability/heartbeat every 30s
 * whenever the current user is an admin or orestore_admin AND the tab is
 * visible. This means anywhere in the app — Dashboard, Profile, Admin page,
 * OreStore page — the admin will register as ONLINE on the public availability
 * widget without having to sit on the OreStore admin dashboard.
 *
 * Render this component once near the top of the React tree.
 */
const AdminOreStoreHeartbeat = () => {
  const { user } = useAuth();
  const isAdmin = !!(user && (user.is_admin || user.is_orestore_admin));

  useEffect(() => {
    if (!isAdmin) return undefined;

    let cancelled = false;
    let timer = null;

    const fire = async () => {
      if (document.hidden) return;
      try {
        await axios.post(
          `${API_URL}/api/admin/orestore/availability/heartbeat`,
          {},
          { headers: getAuthHeaders() }
        );
      } catch (e) {
        // silent — auth may have expired etc.
      }
    };

    fire();
    timer = setInterval(() => {
      if (!cancelled) fire();
    }, HEARTBEAT_INTERVAL_MS);

    const onVisible = () => {
      if (!cancelled && !document.hidden) fire();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      cancelled = true;
      if (timer) clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [isAdmin]);

  return null;
};

export default AdminOreStoreHeartbeat;
